import { Divider, Button } from 'antd';

interface MobileFooterProps {
  next?: () => void;
  nextButtonText?: string;
  previous?: () => void;
  isPrevious?: boolean;
}

const MobileFooter: React.FC<MobileFooterProps> = ({ next, nextButtonText, previous, isPrevious }) => {
  return (
    <>
      <div className='block md:hidden fixed bottom-0 left-0 right-0 bg-white p-4'>
        <div className='flex justify-between border-t border-gray-200 pt-7'>
          {isPrevious ?
            <Button onClick={previous}>Previous</Button>
            : <div></div>}
          <Button onClick={next} type='primary'>{nextButtonText ? nextButtonText : 'Next'}</Button>
        </div>
      </div >
    </>
  );
};

export default MobileFooter;
